import React from 'react';
import { render } from 'react-dom';
//import { InertiaApp } from '@inertiajs/react';

import * as Sentry from '@sentry/browser';
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client';
import sessionManager from '@/Utils/SessionManager';

// InertiaProgress.init({
//   color: '#ED8936',
//   showSpinner: true
// });

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN
});

const app = document.getElementById('app');

// Initialize session manager globally
sessionManager.init();

// render(
//   <InertiaApp
//     initialPage={JSON.parse(app.dataset.page)}
//     resolveComponent={name =>
//       import(`./Pages/${name}`).then(module => module.default)
//     }
//   />,
//   app
// );



// Make sessionManager available globally for logout functionality
window.sessionManager = sessionManager;

createInertiaApp({
  resolve: name => import(`./Pages/${name}`),
  setup({ el, App, props }) {
     createRoot(el).render(<App {...props} />);
  }
});
